// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import SelectStatusInternal from '@/modules/common/components/SelectStatusInternal';
import { withFetch } from '~/hocs/fetch';

const initialValues = {
    code: '',
    status: '',
    internal: '0'
};

const initialErrors = {
    code: '',
    status: '',
    internal: ''
};

let abortController;

const DialogAdd = (props) => {
    const offerName = props.match.params.offerName;

    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({code: '', status: '', internal: ''});
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.post(
            '/api/statuses/',
            {offer_name: offerName, code: parseInt(values.code), ...values},
            abortController
        ).then(({ok, data}) => {
            if (ok) {
                props.onOk(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.code = (data.code) ? data.code[0] : '';
                _errors.status = (data.status) ? data.status[0] : '';
                _errors.internal = (data.internal) ? data.internal[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    const handleClose = () => {
        clear();
        props.setOpen(false);
    };

    return (
        <DialogForm title="Добавление статуса" label="Добавить"
                    open={props.open} onSubmit={handleSubmit} onClose={handleClose}
                    disabled={fetching}
        >
            <TextField label="Код" type="number" inputProps={{min: 0}}
                       value={values.code} onChange={handleChange('code')}
                       error={errors.code.length > 0}
                       helperText={errors.code}
                       onFocus={handleFocus('code')}
                       autoFocus={true}
            />
            <TextField label="Статус"
                       value={values.status} onChange={handleChange('status')}
                       error={errors.status.length > 0}
                       helperText={errors.status}
                       onFocus={handleFocus('status')}
            />
            <SelectStatusInternal value={values.internal} onChange={handleChange('internal')}
                                  showEmpty={false}
            />
        </DialogForm>
    );
};

DialogAdd.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogAdd;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;
